module.exports = __webpack_public_path__ + "img/g2.603d2751.png";